import axios from 'axios';
import * as url from "../config/BackendConfig";


class UtilityService {

    getSubscriptionPlans = (lang='en') => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Authorization': null,
                'Content-Type': "application/json",
            },
        };

        const requestUrl = url.BACKEND_BASE_URL + url.SUBSCRIPTION_PLANS;
        return axios.get(requestUrl, config);
    };


    getMarkets = (lang='en') => {
        const config = {
            headers: {
                'Lang': lang,
                'App': 'web',
                'Authorization': null,
                'Content-Type': "application/json",
            },
        };

        const requestUrl = url.BACKEND_BASE_URL + url.MARKETS;
        return axios.get(requestUrl, config);
    };

}

const UtilityServiceInstance = new UtilityService();
export default UtilityServiceInstance;